import Vue from 'vue'
import Router from 'vue-router'
import AsyncComponent from './asyncComponent.js'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
const systemconf = JSON.parse(localStorage.getItem('systemconf') || '{}')
const huisuiyun = {
  mode: 'history',
  routes: [
    {
      path: '/',
      component: systemconf.isH5Plus ? AsyncComponent({ loadFunc: () => import('@layouts/indexPlus.vue'), loadModel: () => import('@models/user.js') }) : AsyncComponent({ loadFunc: () => import('@layouts/index.vue'), loadModel: () => import('@models/user.js') }),
      children: [
        {
          path: '/',
          name: '/',
          component: systemconf.isH5Plus ? () => import('@/pluspages/Home/index.vue') : () => import('@pages/Home/index.vue'),
          meta: {
            headerBgClass: 'blue',
            isShowfaceRecognition: true,
            isShowETaxLogin: true
          }
        },
        {
          path: '/smart-invoice',
          name: '/smart-invoice',
          component: () => import('@pages/SmartInvoice/index.vue'),
          meta: {
            hideFooter: true
          }
        },
        {
          path: '/invoice/invoice-home',
          name: '开票首页',
          component: () => import('@pages/Customer/InvoiceHome/index.vue'),
          meta: {
            withGoBack: true,
            hideFooter: true
          }
        },
        {
          path: '/invoice/income-home',
          name: '收票首页',
          component: () => import('@pages/Customer/IncomeHome/index.vue'),
          meta: {
            // keepAlive: true,
            withGoBack: true,
            hideFooter: true
          }
        }
      ]
    },
    {
      path: '/ticket',
      name: 'ticket',
      component: systemconf.isH5Plus ? () => import('@layouts/indexPlus.vue') : () => import('@layouts/index.vue'),
      children: [
        {
          path: '/ticket/center/index',
          name: '个人票夹',
          component: () => import('@/pages/Ticket/Center/index.vue'),
          meta: {
            headerBgClass: 'blue'
          }
        }
      ]
    },
    {
      path: '/invoice-opening',
      name: 'invoice-opening',
      component: () => import('@layouts/indexPlus.vue'),
      children: [
        {
          path: '/invoice-opening/index',
          name: '发票填开',
          component: () => import('@/pages/Invoice/InvoiceOpening/index.vue'),
          meta: {
            headerBgClass: 'blue',
            hideFooter: true,
            showGuide: true
          }
        },
        {
          path: '/invoice-opening/preview',
          name: '发票填开(预览)',
          component: () => import('@/pages/Invoice/InvoiceOpening/preview.vue'),
          meta: {
            headerBgClass: 'blue',
            hideFooter: true,
            hideInvoiceNum: true,
            hideChangeCompany: true
          }
        },
        {
          path: '/invoice-opening/result',
          name: '发票开具结果',
          component: () => import('@/pages/Invoice/InvoicingResults/index.vue'),
          meta: {
            headerBgClass: 'blue'
          }
        },
        {
          path: '/invoice-red/index',
          name: '发票红冲',
          component: () => import('@/pages/Invoice/InvoiceRed/index.vue'),
          meta: {
            headerBgClass: 'blue',
            hideFooter: true,
            showGuide: true
          }
        },
        {
          path: '/invoice-red/opening',
          name: '发票红冲(填开)',
          component: () => import('@/pages/Invoice/InvoiceRed/opening.vue'),
          meta: {
            headerBgClass: 'blue',
            hideFooter: true
          }
        },
        {
          path: '/invoice-red/confirm',
          name: '确认红字发票信息',
          component: () => import('@/pages/Invoice/InvoiceRed/redInvoiceConfirm.vue'),
          meta: {
            headerBgClass: 'blue',
            hideFooter: true
          }
        },
        {
          path: '/invoice-list/info',
          name: '已开发票查看',
          component: () => import('@/pages/Invoice/DoneInvoiceList/info.vue'),
          meta: {
            headerBgClass: 'blue',
            hideFooter: true
          }
        },
        {
          path: '/invoice-list/index',
          name: '已开发票',
          component: () => import('@/pages/Invoice/DoneInvoiceList/index.vue'),
          meta: {
            headerBgClass: 'blue'
          }
        },
        {
          path: '/small-bell/message',
          name: '铃铛消息',
          component: () => import('@/pluspages/Message/index.vue'),
          meta: {
            headerBgClass: 'blue',
            hideFooter: true
          }
        }
      ]
    },
    {
      path: '/normal-travel/index',
      name: 'normal-travel/index',
      meta: {
        withGoBack: true
      },
      component: () => import('@/pages/Ticket/CenterInfo/NormalTravel/index.vue'),
      params: {
        detailData: {}
      }
    },
    {
      path: '/my-examine/list',
      name: 'myExamine/list',
      component: AsyncComponent({ loadFunc: () => import('@/pages/MyExamine/index.vue'), loadModel: () => import('@/pages/MyExamine/models/index.js') })
    },
    {
      path: '/my-examine/page',
      name: 'my-examine/page',
      props: (route) => ({
        examineId: route.query.examineId,
        reimNo: route.query.reimNo
      }),
      component: () => import('@/pages/MyExamine/info.vue')
    },
    {
      path: '/reimbursement/reimList',
      name: 'reimbursement/reimList',
      component: () => import('@/pages/Reimbursement/ReimList/index.vue')
    },
    {
      path: '/reimbursement/launch-reim',
      name: 'reimbursement/launch-reim',
      component: () => import('@/pages/Reimbursement/LaunchReim/index.vue')
    },
    {
      path: '/reimbursement/reimInfo',
      name: 'reimbursement/reimInfo',
      component: () => import('@/pages/Reimbursement/ReimInfo/index.vue')
    },
    {
      path: '/test/index',
      name: 'test/index',
      meta: {
        showClear: true
      },
      component: () => import('@/pages/Test/index.vue')
    },
    {
      path: '/invoice/add-apply',
      name: 'invoice/add-apply',
      meta: {
        showClear: true,
        withGoBack: true
      },
      component: () => import('@pages/Customer/ApplyEditor/index.vue')
    },
    {
      path: '/invoice/detail',
      name: 'invoice/detail',
      meta: {
        withGoBack: true
      },
      component: () => import('@pages/Customer/ApplyConfirm/index.vue'),
      params: {
        detailData: {}
      }
    },
    {
      path: '/invoice/goods-list',
      name: 'invoice/goods-list',
      meta: {
        withGoBack: true
      },
      component: () => import('@pages/Customer/GoodsList/index.vue')
    },
    {
      path: '/normed/index',
      name: 'normed/index',
      meta: {
        withGoBack: true
      },
      component: () => import('@/pages/Ticket/CenterInfo/Normed/index.vue'),
      params: {
        detailData: {}
      }
    },
    {
      path: '/electricity/index',
      name: 'electricity/index',
      component: () => import('@/pages/Ticket/CenterInfo/Electricity/index.vue')
    },
    {
      path: '/electricity-travel/index',
      name: 'electricity-travel/index',
      component: () => import('@/pages/Ticket/CenterInfo/ElectricityTravel/index.vue')
    },
    {
      path: '/share',
      component: () => import('@layouts/blank.vue'),
      children: [
        {
          path: '/',
          name: 'share',
          component: () => import('@pages/Share/index.vue')
        }
      ]
    },
    {
      path: '/invoice',
      component: AsyncComponent({ loadFunc: () => import('@layouts/header.vue'), loadModel: () => import('@models/invoice.js') }),
      children: [
        {
          path: '/invoice/collect',
          name: '识别结果',
          component: () => import('@pages/OfficialAccount/InvocieCollect/index.vue'),
          meta: {
            withGoBack: true
          }
        },
        {
          path: '/newInvoice/collect',
          name: '识别结果',
          component: () => import('@pages/OfficialAccount/NewInvocieCollect/index.vue'),
          meta: {
            withGoBack: true
          }
        },
        {
          path: '/newInvoice/newCollect',
          name: '识别结果',
          component: () => import('@pages/OfficialAccount/NewInvocieCollect/newIndex.vue'),
          meta: {
            withGoBack: true
          }
        },
        {
          path: '/newInvoice/editInvoice',
          name: '修改发票',
          component: () => import('@pages/OfficialAccount/NewInvocieCollect/editInvoice.vue'),
          meta: {
            withGoBack: true
          }
        },
        {
          path: '/invoice/income/invoice',
          name: '收票详情',
          component: () => import('@pages/OfficialAccount/InvoiceInfo/index.vue'),
          meta: {
            withGoBack: true
          }
        },
        {
          path: '/invoice/income/edit',
          name: '识别结果',
          component: () => import('@pages/OfficialAccount/InvoiceInfoEdit/index.vue'),
          meta: {
            withGoBack: true
          }
        },
        {
          path: '/invoice/apply-list',
          name: '申请列表',
          component: () => import('@pages/Customer/ApplyList/index.vue'),
          meta: {
            keepAlive: true,
            withGoBack: true
          }
        },
        {
          path: '/invoice/add-goods',
          name: '商品货物新增',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/Customer/GoodsEditor/index.vue')
        },
        {
          path: '/invoice/receiver-list',
          name: '客户收件信息',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/Customer/ReceiverList/index.vue')
        },
        {
          path: '/invoice/add-receiver',
          name: '收件信息',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/Customer/ReceiverEditor/index.vue')
        },
        {
          path: '/invoice/statistics',
          name: '发票汇总',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/Customer/InvoiceStat/index.vue')
        },
        {
          path: '/invoice/applyinfo',
          name: '开票详情',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/Customer/ApplyConfirm/index.vue'),
          params: {
            detailData: {}
          }
        },
        {
          path: '/invoice/info',
          name: '开票详情 ',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/Customer/ApplyConfirm/index.vue'),
          params: {
            detailData: {}
          }
        },
        {
          path: '/apply/info',
          name: '开票详情 ',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/Customer/ApplyInfo/index.vue'),
          params: {
            detailData: {}
          }
        },
        {
          path: '/invoice/uninvoice/info',
          name: '电票直开详情 ',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/Customer/ApplyConfirm/index.vue'),
          params: {
            detailData: {}
          }
        },
        {
          path: '/invoice/express',
          name: '物流跟踪',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/Customer/Express/index.vue')
        },
        {
          path: '/invoice/business/open',
          name: '电票直开',
          meta: {
            withGoBack: true,
            showGuide: true
          },
          component: () => import('@pages/Business/Index/index.vue')
        },
        {
          path: '/invoice/business/show',
          name: '扫码开票',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/Business/BusinessQrCode/index.vue')
        },
        {
          path: '/invoice/data-center',
          name: '数据中心',
          component: () => import('@pages/Customer/DataCenter/index.vue'),
          meta: {
            withGoBack: true
          }
        }
      ]
    },
    {
      path: '/user',
      component: () => import('@layouts/header.vue'),
      children: [
        {
          path: '/user/login',
          name: '登录',
          meta: {
            hideHeader: true
          },
          component: () => import('@pages/Login/login.vue')
        },
        {
          path: '/user/forget-password',
          name: '忘记密码',
          component: () => import('@pages/Login/forgetPassword.vue')
        }
      ]
    },
    {
      path: '/faceRecognition',
      component: () => import('@layouts/header.vue'),
      children: [
        {
          path: '/faceRecognition/index',
          name: '人脸认证',
          component: () => import('@/pages/FaceRecognition/index.vue'),
          meta: {
            withGoBack: true
          }
        }
      ]
    },
    {
      path: '/eTaxLogin',
      component: () => import('@layouts/header.vue'),
      children: [
        {
          path: '/eTaxLogin/index',
          name: '登录电子税局',
          component: () => import('@/pages/ETaxLogin/index.vue'),
          meta: {
            withGoBack: true
          }
        }
      ]
    },
    {
      path: '/user-center',
      name: 'user-center',
      component: systemconf.isH5Plus ? () => import('@layouts/headerAndFooterPlus.vue') : () => import('@layouts/headerAndFooter.vue'),
      children: [
        {
          path: '/user-center/index',
          name: '我的',
          component: () => import('@pages/UserCenter/index.vue')
        }
      ]
    },
    {
      path: '/user-center',
      name: 'user-center-no-tab',
      component: () => import('@layouts/header.vue'),
      children: [
        {
          path: '/user-center/reset-password',
          name: '修改密码',
          component: () => import('@pages/UserCenter/ResetPassword/index.vue'),
          meta: {
            withGoBack: true
          }
        },
        {
          path: '/user-center/user-info',
          name: '账号信息',
          component: () => import('@pages/UserCenter/UserInfo/index.vue'),
          meta: {
            withGoBack: true
          }
        },
        {
          path: '/user-center/company-info',
          name: '我的企业',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/UserCenter/CompanyInfo/index.vue')
        },
        {
          path: '/user-center/company-qrcode',
          name: '企业开票码',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/UserCenter/CompanyQrCode/index.vue')
        },
        {
          path: '/user-center/user-agreement',
          name: '用户协议',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/UserCenter/UserAgreement/index.vue')
        },
        {
          path: '/customer/list',
          name: '我的客户',
          component: () => import('@pages/Customer/CustomerList/index.vue'),
          meta: {
            withGoBack: true
          }
        },
        {
          path: '/user-center/staff-list',
          name: '我的员工',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/UserCenter/StaffList/index.vue')
        },
        {
          path: '/user-center/information',
          name: '信息管理',
          component: () => import('@pages/UserCenter/Infomation/index.vue'),
          meta: {
            withGoBack: true
          }
        },
        {
          path: '/user-center/goodsList',
          name: '商品列表',
          component: () => import('@pages/UserCenter/GoodsList/index.vue'),
          meta: {
            withGoBack: true
          }
        },
        {
          path: '/user-center/goodsList/page',
          name: '商品详情',
          component: () => import('@pages/UserCenter/GoodsList/page.vue'),
          meta: {
            withGoBack: true
          }
        }
      ]
    },
    {
      path: '/customer',
      name: 'customer-no-tab',
      component: () => import('@layouts/header.vue'),
      children: [
        {
          path: '/customer/edit/:id',
          name: '编辑客户信息',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/Customer/CustomerEdit/index.vue')
        },
        {
          path: '/customer/add',
          name: '新增客户信息',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/Customer/CustomerAdd/index.vue')
        },
        {
          path: '/customer/detail/:id',
          name: '客户详情',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/Customer/CustomerDetail/index.vue')
        },
        {
          path: '/customer/address/:type',
          name: '收件地址',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/Customer/CustomerAddressEdit/index.vue')
        }
      ]
    },
    {
      path: '/message',
      name: 'message',
      component: systemconf.isH5Plus ? () => import('@layouts/headerAndFooterPlus.vue') : () => import('@layouts/headerAndFooter.vue'),
      children: [
        {
          path: '/message/center',
          name: '消息中心',
          component: () => systemconf.isH5Plus ? import('@/pluspages/Message/index.vue') : import('@pages/Message/MessageCenter/index.vue'),
          meta: {
            title: ''
          }
        }
      ]
    },
    {
      path: '/message',
      name: 'message-no-tab',
      component: () => import('@layouts/header.vue'),
      children: [
        {
          path: '/message/detail',
          name: '公告详情',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/Message/MessageDetail/index.vue')
        },
        {
          path: '/message/unsend',
          name: '待寄送',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/Message/UnSendInvoice/index.vue')
        },
        {
          path: '/message/unreceive',
          name: '待签收',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/Message/UnReceiveInvoice/index.vue')
        },
        {
          path: '/message/express',
          name: '物流跟踪',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/Message/Express/index.vue')
        }
      ]
    },
    {
      path: '/order',
      component: () => import('@layouts/blank.vue'),
      children: [
        {
          path: '/',
          name: 'order',
          component: () => import('@pages/Business/Order/index.vue')
        },
        {
          path: '/order/apply-success',
          name: 'apply-success',
          component: () => import('@pages/Business/ApplySuccess/index.vue')
        },
        {
          path: '/order/scan-invoice',
          name: 'scaninvoice',
          component: () => import('@pages/Business/ScanInvoice/index.vue')
        },
        {
          path: '/order/overdue',
          name: 'customer-overdue',
          component: () => import('@pages/Business/Overdue/index.vue')
        }
      ]
    },
    {
      path: '/audit-invoicing',
      component: () => import('@layouts/blank.vue'),
      children: [
        {
          path: '/',
          name: '填写发票信息',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/Invoice/AuditInvoicing/index.vue')
        },
        {
          path: '/audit-invoicing/submit-finish',
          name: '提示',
          meta: {
            withGoBack: true
          },
          component: () => import('@pages/Invoice/AuditInvoicing/finish.vue')
        }
      ]
    },
    {
      path: '/ukey',
      component: () => import('@layouts/blank.vue'),
      children: [
        {
          path: '/',
          name: 'ukey',
          component: () => import('@pages/UkeyBox/BindingUkey/index.vue')
        },
        {
          path: '/ukey/send-code',
          name: 'send-code',
          component: () => import('@pages/UkeyBox/SendCode/index.vue')
        },
        {
          path: '/ukey/set-password',
          name: 'set-password',
          component: () => import('@pages/UkeyBox/SetPassword/index.vue')
        },
        {
          path: '/ukey/binding',
          name: 'binding',
          component: () => import('@pages/UkeyBox/Binding/index.vue')
        },
        {
          path: '/ukey/holding-password',
          name: 'holding-password',
          component: () => import('@pages/UkeyBox/HoldingPassword/index.vue')
        },
        {
          path: '/ukey/noDisc',
          name: 'ukey/noDisc',
          component: () => import('@pages/UkeyBox/noDisc.vue')
        }
      ]
    },
    {
      path: '/customer-invoice',
      component: () => import('@layouts/blank.vue'),
      children: [
        {
          path: '/',
          name: 'customer-invoice',
          component: () => import('@pages/Customer/Invoice/index.vue')
        }
      ]
    },
    {
      path: '/inv',
      component: () => import('@layouts/blank.vue'),
      children: [
        {
          path: '/',
          name: 'inv',
          component: () => import('@pages/Customer/Invoice/index.vue')
        }
      ]
    },
    {
      path: '/not-found',
      name: 'not-found',
      component: () => import('@pages/NotFound.vue')
    }
  ]
}
export default new Router(huisuiyun)
